import React, { useEffect, useRef, useState } from 'react'
import { Spinner, UserProfileImage } from '../../common'
import Popover from '../../Popover'
import t from '../../i18n/I18n'
import $ from 'jquery';
import Authenticator from '../../protocol/Authenticator'
import Storage from '../../protocol/Storage'
import ParamsUtil from '../../util/ParamsUtil'
import ConnectionUtil from '../../util/session/ConnectionUtil'
import EditUser from '../../queries/user/EditUser';
import ThumbnailUtil from '../../util/ThumbnailUtil';
import { toast } from '../../store/StoreUtil';

const EditProfileImage = () => {
    const [showPopover, setPopover] = useState(false);
    const [uploadProfilePic, setUploadProfilePic] = useState(null)
    const [isUserImage, setIsUserImage] = useState(true);
    const [uploading, setUploading] = useState(false);
    const uploadRef = useRef();
    let isImageRemoved = false;
    let userId = Authenticator.AUTH_DATA.username;
    const setError = (error) => {
      setUploading(false);
      window.setError(error);
    }
    
    const isUserImageIdExists = async () => {
      let url = ParamsUtil.append(ConnectionUtil.getPreviewServerUrl() + '/review/api/user/avatarId');
      url = ParamsUtil.appendAuthData(url);
      var formData = new FormData();
      formData.append('userId', userId);
      await $.ajax({
        url: url,
        crossDomain: true,
        xhrFields: {
          withCredentials: true
        },
        data: { userId: userId },
        success: (response) => {
          if (response) {
            if (response.avatarId > 0) {
              setIsUserImage(true);
            } else  {
              setIsUserImage(false);
            }
          }
        },
        error: (errorId) => {
          // setError(errorId.statusText);
        }
      });
    };

    useEffect(() => {
      isUserImageIdExists();
    }, [])

    const showPreviewOfUploadProfilePic = (file) => {
        if (file) {
          let dataTransferFile = file;
          let reader = new FileReader();
          reader.onloadend = () => setUploadProfilePic(reader.result);
          reader.readAsDataURL(dataTransferFile);
        }
    };

    const onEditUserSuccess = () => {
      isImageRemoved ? setIsUserImage(false) : setIsUserImage(true)
      toast(t('USER_PROFILE_EDITED'));
      let userId = ConnectionUtil.getUserId();
      $.get(
        ParamsUtil.appendAuthData(`${ConnectionUtil.getPreviewServerUrl()}/review/api/user/invalidate-avatar/${userId}`)
      ).always(() => {
        Storage.set('AVATAR_DC', Date.now());
        setUploadProfilePic(ThumbnailUtil.avatar(userId))
        setUploading(false);
        window.render();
      });
    };

    const onEditUserFailed = (errorId) => {
      setError(errorId.toString());
    };

    const editAccount = (profileFileId, profilePicName, isRomoved = false ) => {
        const editUserAccount = new EditUser();
        const promise = editUserAccount.editUser(
          userId,
          '',
          '',
          profileFileId,
          profilePicName,
          isRomoved
        );
        promise.then(onEditUserSuccess, onEditUserFailed);
      };

    const uploadImageAndEditAccount = (file) => {
        let fileExtension = file.name.split('.').pop();
        const url = ConnectionUtil.getAvatarUploadURL();
        let formData = new FormData();
        formData.append('profilePicFile', file);
        $.ajax({
          url: url,
          type: 'POST',
          processData: false,
          contentType: false,
          async: true,
          cache: false,
          data: formData,
          success: (response) => {
            if (response.success) {
              let profileFileId = response.fileId;
              let profilePicName = userId + '.' + fileExtension;
              showPreviewOfUploadProfilePic(file);
              editAccount(profileFileId, profilePicName);
            } else {
              setError( response.error );
            }
          },
          error: (errorId) => {
            setError(errorId instanceof String ? errorId.toString() : errorId.statusText);
          }
        });
      };
      const removeProfilePic = () => {
        setPopover(false)
        Storage.set('AVATAR_DC', Date.now());
        isImageRemoved = true;
        editAccount('','', true);
        setUploadProfilePic(ThumbnailUtil.avatar(userId))
    }

    const handleFilePicker = (event) =>{
        setUploading(true);
        try {
            setPopover(false)
            const allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i;
            if (event.target.files && event.target.files.length === 1) {
              let newProfileImage = event.target.files[0];
              if (newProfileImage.type.substr(0, 5) === 'image' && allowedExtensions.exec(newProfileImage.name)) {
                isImageRemoved = false;
                uploadImageAndEditAccount(newProfileImage)
              } else {
                setError(t('UPLOAD_FILE_HAVING_EXTENSIONS'))
              }
            }
          } catch (e) {
            console.warn(e);
          }
    }

    const styles = {
        editIcon: {
          fontFamily: 'fontAwesome'
        },
        option: {
          cursor: 'pointer',
          color: 'var(--primary-font-color)',
          fontSize: '14px',
          marginBottom: '10px',
          textAlign: 'left'
        }
      }

    return (
        <div>
            <div className='outer'>
                <UserProfileImage imageUrl={uploadProfilePic} size={80} userId={userId} />
                {uploading ? <div className="loading"><Spinner/></div> :
                 <div>
                  <div className={`upload ${!isUserImage ? 'not-uploaded' :''}`} onClick={() => uploadRef.current.click()} ><span> Upload </span></div>
                    <input
                      type="file"
                      ref={uploadRef}
                      accept="image/*"
                      style={{ display: 'none' }}
                      onChange={handleFilePicker}
                    />
                    {isUserImage && <div className='remove' onClick={removeProfilePic} ><span> Remove </span></div>}
                  </div>  
               }          
            </div>
          </div>
    )
}

export default EditProfileImage